import { CompactColorPickerInput } from "@/overlay/components/LayerStackWindow/LayerFormElements/CompactColorPickerInput";
import type { ElementStyle } from "@mm/metx-workbench.meteomatics.com";
import { MmFabButton, MmToggleButton } from "@mm/zeus-react";
import { useState } from "react";
import styles from "./Control.module.scss";

type StyleControlsProps = {
  titleStyle: ElementStyle;
  onStyleChange: (newStyle: ElementStyle) => void;
  registerCloseHandler?: (handler: (() => boolean) | null) => void;
};

export function TitleStyleControl({ titleStyle, onStyleChange, registerCloseHandler }: StyleControlsProps) {
  const [fontSize, setFontSize] = useState<number>(titleStyle.fontSize || 16);

  const toggleStyle = (styleProp: keyof ElementStyle, activeValue: string | number, normalValue: string | number) => {
    const newStyle = {
      ...titleStyle,
      [styleProp]: titleStyle[styleProp] === activeValue ? normalValue : activeValue, // Toggle the style
    };
    onStyleChange(newStyle);
  };

  const changeColor = (newColor: string) => {
    const newStyle = {
      ...titleStyle,
      color: newColor,
    };
    onStyleChange(newStyle);
  };

  const changeFontSize = (sizeChange: number) => {
    const newFontSize = fontSize + sizeChange;
    setFontSize(newFontSize);
    onStyleChange({ ...titleStyle, fontSize: newFontSize });
  };

  return (
    <div className={styles["style-controls"]} data-testid={"title-style-control"}>
      <MmToggleButton
        bold={true}
        toggled={titleStyle.fontWeight === 700}
        onClick={() => toggleStyle("fontWeight", 700, 400)}
      >
        <b>B</b>
      </MmToggleButton>
      <MmToggleButton
        italic={true}
        toggled={titleStyle.fontStyle === "italic"}
        onClick={() => {
          onStyleChange({ ...titleStyle, fontStyle: titleStyle.fontStyle === "italic" ? "normal" : "italic" });
        }}
      >
        <i>I</i>
      </MmToggleButton>
      <MmToggleButton
        underlined={true}
        toggled={titleStyle.textDecoration === "underline"}
        onClick={() => {
          onStyleChange({
            ...titleStyle,
            textDecoration: titleStyle.textDecoration === "underline" ? "none" : "underline",
          });
        }}
      >
        <u>U</u>
      </MmToggleButton>
      <CompactColorPickerInput
        value={titleStyle.color || "#000000"}
        change={(newColor) => changeColor(newColor)}
        placement="bottom-end"
        registerCloseHandler={registerCloseHandler}
      />
      <div className={styles["font-size-controls"]}>
        <span>{fontSize}</span>
        <MmFabButton
          iconname={"remove"}
          onClick={() => changeFontSize(-1)}
          rounded={true}
          size="xsmall"
          disabled={fontSize === 13}
        />
        <MmFabButton iconname="add" onClick={() => changeFontSize(1)} rounded={true} size="xsmall" />
      </div>
    </div>
  );
}
